import { Component, EventEmitter, HostBinding, Input, OnInit, Output } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { Store } from '@ngrx/store';
import { I18NextPipe } from "angular-i18next";
import { Observable, Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { DialogCategoriesComponent } from "src/app/common/dialogs/dialog-categories/dialog-categories.component";
import { DialogDateFiltersComponent } from "src/app/common/dialogs/dialog-date-filters/dialog-date-filters.component";
import { ErrorMessage, InfoMessage } from 'src/app/common/messages';
import { DatetimepickerModel, DialogDatetimepickerComponent } from "src/app/dashboards/components/dialog-datetimepicker/dialog-datetimepicker.component";
import { report, saveReportModel } from "src/app/dashboards/models";
import { State } from 'src/app/dashboards/state';
import { gridItem } from "src/app/models";
import { DialogSaveAsEditData, DialogSaveAsEditTypes, ReportsDialogSaveAsEditComponent } from 'src/app/reports/reports-details/nested-components/reports-dialog-save-as-edit/reports-dialog-save-as-edit.component';
import { DashboardService } from "src/app/services/services/dashboard.service";
import { MatCheckboxModule } from '@angular/material/checkbox';
import * as mainActions from 'src/app/state/app.actions';

@Component({
    selector: 'app-reports-settings',
    templateUrl: './reports-settings.component.html',
    styleUrls: ['./reports-settings.component.scss'],
    standalone: false
})

export class ReportsSettingsComponent implements OnInit {
    @Input() public gridItem: gridItem;
    @Input() public report: report;
    @Input() public notifier: Subject<any>;
    @Input() public isStandAlone: boolean;
    @Output() public completedNotifier = new EventEmitter<boolean>();
    @Output() public viewReport: EventEmitter<any> = new EventEmitter();
    @Output() public refreshNotifier = new EventEmitter<boolean>();

    @HostBinding('style.min-height') hostMinHeight = '500px';

    dataLoaded: boolean = true;
    //loadingData: boolean = false;
    readyToShowReport: boolean = false;
    limitRange: boolean = false;

    selectedReport: any = {};
    serviceNumbers: any[] = [];
    sysShowEmpty: any;
    sysAgentNoCalls: any;
    sysGroupByTime: any[] = [];
    columns: any[] = [];
    defaultColumns: any[] = [];
    relativeFromCompleted: boolean = false;
    relativeToCompleted: boolean = false;
    canEdit: boolean = false;
    categories: any[] = [];

    userGroupsRes: any[] = [];

    agents$: Observable<any[]>;
    userGroups$: Observable<any[]>;
    queues$: Observable<any[]>;
    terminatingNumbers$: Observable<any[]>;
    menus$: Observable<any[]>;
    accesspoints: any[];

    visualTypedisabledItems: number[] = [3];
    sysDimsForFilter: string[] = [];

    ngUnsubscribe = new Subject<void>();

    constructor(private DashboardsService: DashboardService, private i18nextPipe: I18NextPipe, public dialog: MatDialog, private store: Store<State>) { }

    ngOnInit(): void {
        this.hostMinHeight = this.isStandAlone ? "auto" : "500px";
        this.completedNotifier.subscribe(completed => {
            this.limitRange = this.gridItem.setup.limitRange ?? false;
            this.readyToShowReport = completed;
        });
        this.notifier.pipe(takeUntil(this.ngUnsubscribe)).subscribe(value => {
            setTimeout(() => {
                this.loadReportData(this.report);
            }, 0)
        });
        this.DashboardsService.getReportCategories().subscribe(reportCategories => {
            this.categories = JSON.parse(JSON.stringify(reportCategories));
        });
        this.agents$ = this.DashboardsService.getReportRowsFilter('A', '');
        this.userGroups$ = this.DashboardsService.getReportRowsFilter('G', '');
        this.userGroups$.subscribe(r => {
            let uniqueValueIds = [];
            for (let i = 0; i < r.length; i++) {
                let valueId = r[i]["usergroupId"];
                if (uniqueValueIds.indexOf(valueId) > -1) {

                } else {
                    uniqueValueIds.push(valueId)
                }
            }

            for (let i = 0; i < uniqueValueIds.length; i++) {
                let id = uniqueValueIds[i];
                let userGroupsById = r.filter(x => x.usergroupId === id);
                for (let j = 0; j < userGroupsById.length; j++) {
                    let userGroup = userGroupsById[j];
                    if (j !== 0) {
                        userGroup["usergroupId"] = userGroup["usergroupId"] + "_" + j;
                    } else {
                        userGroup["usergroupId"] = userGroup["usergroupId"].toString();
                    }

                    this.userGroupsRes.push(userGroup);
                }
            }
        });
        this.queues$ = this.DashboardsService.getReportRowsFilter('Q', '');
        this.terminatingNumbers$ = this.DashboardsService.getReportRowsFilter('T', '');
        this.menus$ = this.DashboardsService.getReportRowsFilter('M', '');
        this.DashboardsService.getReportsCanEdit().subscribe(value => this.canEdit = value);
        if (this.gridItem.setup.reportId) {
            let report = {
                id: this.gridItem.setup.reportId,
                subReportId: 0
            }
            this.loadReportData(report);
        }
        setTimeout(() => this.modelChange(), 0);
    }

    ngOnDestroy(): void {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    }

    showReport() {
        this.viewReport.emit();
    }

    saveAsReport() {
        let dialogRef = this.dialog.open(ReportsDialogSaveAsEditComponent, {
            data: new DialogSaveAsEditData({ ...this.report }, DialogSaveAsEditTypes.SaveAs, this.gridItem),
            width: "440px",
            height: "400px"
        });
        dialogRef.afterClosed().subscribe(result => {
            if (result) this.refreshNotifier.emit(true);
        });
    }

    saveReport() {
        this.gridItem.setup.reportType = this.gridItem.type;
        const saveReportModel: saveReportModel = {
            setup: this.gridItem.setup,
            id: this.report.id,
            shortDescription: this.report.shortDescription,
            subReportId: this.report.subReportId,
            userDescription: this.report.userDescription === undefined ? "" : this.report.userDescription,
            // Because the type of categoryId is nullable number, not a string or undefined
            categoryId: !this.report.categoryId ? null : this.report.categoryId
        };

        this.DashboardsService.SaveReport(saveReportModel).subscribe(
            (d) => {
                if (d == 0) {
                    this.store.dispatch(mainActions.addMessage({ message: new InfoMessage(this.i18nextPipe.transform('messages:Report Saved!'), "") }));
                } else if (d == -2) {
                    this.store.dispatch(mainActions.addMessage({
                        message: new ErrorMessage(
                            this.i18nextPipe.transform("messages:Couldn't save report!"),
                            this.i18nextPipe.transform('messages:Name is in use.'))
                    }));
                } else {
                    this.store.dispatch(mainActions.addMessage({ message: new ErrorMessage(this.i18nextPipe.transform("messages:Couldn't save report!"), "") }));
                }
            },
            (error) => {
                this.store.dispatch(mainActions.addMessage({ message: new ErrorMessage(this.i18nextPipe.transform("messages:Couldn't save report!"), "") }));
            }
        );
    }

    editReport() {
        let dialogRef = this.dialog.open(ReportsDialogSaveAsEditComponent, {
            data: new DialogSaveAsEditData({ ...this.report }, DialogSaveAsEditTypes.Edit, this.gridItem),
            width: "440px",
            height: "400px"
        });
        dialogRef.afterClosed().subscribe(result => {
            if (result) this.refreshNotifier.emit(true);
        });
    }

    loadReportData(report) {
        this.gridItem.setup.period.type = 1;
        this.modelChange();
        this.dataLoaded = false;
        this.DashboardsService.getReport(report.id, report.subReportId).subscribe(report => {
            this.dataLoaded = true;
            this.selectedReport = report;
            if (report.preset) {
                this.gridItem.setup = { ...this.gridItem.setup, ...report.preset };
                this.gridItem.type = report.preset.reportType;
            }
            let ServiceNum = report.parameters.find(r => r.name == 'ServiceNum');
            let sysGroupByTime = report.parameters.find(r => r.name == 'sysGroupByTime');
            this.sysShowEmpty = report.parameters.find(r => r.name == 'sysShowEmpty' && r.promptUser);
            this.sysAgentNoCalls = report.parameters.find(r => r.name == 'sysAgentNoCalls');
            let sysDimsForFilter = report.parameters.find(r => r.name == 'sysDimsForFilter');

            this.serviceNumbers = ServiceNum ? ServiceNum.customParameters : [];
            this.sysGroupByTime = sysGroupByTime ? sysGroupByTime.customParameters : [];

            this.columns = report.allColumns.sort((a, b) => Number(b.isKey) - Number(a.isKey) || a.order - b.order);
            this.defaultColumns = this.gridItem.setup.columns ?? report.defaultColumns.filter(x => !report.allColumns.find(c => c.labelCode === x)?.isKey);

            if (!sysGroupByTime) {
                delete this.gridItem.setup.sysGroupByTime;
            }
            if (this.gridItem.setup.period.from || typeof this.gridItem.setup.period.from === 'string' || this.gridItem.setup.period.from instanceof String) {
                this.gridItem.setup.period.from = new Date(<string>this.gridItem.setup.period.from);
            }
            if (this.gridItem.setup.period.to || typeof this.gridItem.setup.period.to === 'string' || this.gridItem.setup.period.to instanceof String) {
                this.gridItem.setup.period.to = new Date(<string>this.gridItem.setup.period.to);
            }
            if (this.serviceNumbers?.length > 0 && this.gridItem.setup.serviceNumber == null) {
                let sn = this.serviceNumbers.find(s => s.defaultValue == 1)?.key;
                if (!sn && this.serviceNumbers.length == 1) {
                    sn = this.serviceNumbers[0].key;
                }
                else if (!sn) {
                    sn = this.serviceNumbers.find(s => s.key == ServiceNum.defaultValue?.split("#").pop())?.key;
                }
                this.gridItem.setup.serviceNumber = sn;
            }
            this.sysDimsForFilter = (sysDimsForFilter?.sysDimsForFilter || sysDimsForFilter?.value || '').split(',').filter(f => f != '');
            if (this.sysDimsForFilter.indexOf('N') > -1) {
                this.DashboardsService.getReportRowsFilter('N', '').subscribe(n => this.accesspoints = n.map(m => ({ ...m, description: `${m.accesspoint}_${m.description}` })));
            }
            this.gridItem.setup.period.type = 1;
            this.modelChange();
        });
    }

    selectModelChange($event, modelName) {
        this.gridItem.setup[modelName] = $event;
        this.modelChange();
    }

    //// probably not used anymore - cannot find any refernce where it is used
    //clearPeriod() {
    //    setTimeout(() => {
    //        if (this.gridItem.setup.period.type == 1) {
    //            delete this.gridItem.setup.period.from;
    //            delete this.gridItem.setup.period.to;
    //        } else {
    //            delete this.gridItem.setup.period.fromDateType;
    //            delete this.gridItem.setup.period.fromValue;
    //            delete this.gridItem.setup.period.fromTime;
    //            delete this.gridItem.setup.period.toDateType;
    //            delete this.gridItem.setup.period.toValue;
    //            delete this.gridItem.setup.period.toTime;
    //        }
    //        this.modelChange();
    //    }, 0);
    //}

    //// probably not used anymore - cannot find any refernce where it is used
    //showCalendar($event, modelString: string) {
    //    this[`calendar${modelString}Open`] = true;
    //    if (this.gridItem.setup.period.type == 1) return;
    //    const from = this.gridItem.setup.period?.from;
    //    const to = this.gridItem.setup.period?.to;
    //    const minDate = new Date(this.selectedReport?.firstDate);
    //    let data: DatetimepickerModel = { date: this.gridItem.setup.period[modelString], minDate, maxDate: null, medel: modelString };
    //    if (modelString == "to" && from) {
    //        data.minDate = from;
    //        data.maxDate = new Date(new Date(from).setDate(from.getDate() + this.selectedReport?.dataAvailableFor - 1));
    //        if (data.maxDate > new Date() || this.selectedReport?.dataAvailableFor == 0) {
    //            data.maxDate = new Date();
    //        }
    //    }
    //    let position = $event.currentTarget.getBoundingClientRect();
    //    const dialogRef = this.dialog.open(DialogDatetimepickerComponent, {
    //        width: '300px',
    //        data: data,
    //        backdropClass: "backdrop-invisible",
    //        panelClass: "dialog-radius0",
    //        position: { top: `${position.top + 42}px`, left: `${position.left}px` },
    //    });
    //    dialogRef.afterClosed().subscribe(result => {
    //        this[`calendar${modelString}Open`] = false;
    //        if (result) {
    //            this.gridItem.setup.period[modelString] = null;
    //            if (modelString == "from") {
    //                this.gridItem.setup.period.to = null;
    //            }
    //            setTimeout(() => {
    //                this.gridItem.setup.period[modelString] = result.data;
    //                this.modelChange();
    //            }, 0);
    //        }
    //    });
    //}

    dateToString(date) {
        if (!date) return "";
        if (typeof date === 'string' || date instanceof String) {
            date = new Date(<string>date);
        }
        date = new Date(date.getTime() + date.getTimezoneOffset() * 60000);
        return `${date.toLocaleDateString('en-GB')} ${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}`;
    }

    showCategories() {
        const dialogRef = this.dialog.open(DialogCategoriesComponent, {
            panelClass: 'dialog-standard-pannel',
            backdropClass: "backdrop-invisible",
            data: { categories: this.categories },
            width: "495px",
            height: "480px"
        });

        dialogRef.afterClosed().subscribe(data => {
            if (data) {
                this.categories = JSON.parse(JSON.stringify(data.categories));
            }
        });
    }

    showDateFilters() {
        const dialogRef = this.dialog.open(DialogDateFiltersComponent, {
            data: { gridItem: this.gridItem },
            panelClass: 'dialog-standard-pannel',
            backdropClass: "backdrop-invisible",
            width: "400px",
            height: "640px",
        });

        dialogRef.afterClosed().subscribe(data => {
            if (data) {
                this.gridItem.setup.filters = Object.assign({}, data.filters);
            }
        });
    }

    limitRangeClick() {
        this.limitRange = !this.limitRange;
        this.gridItem.setup.limitRange = this.limitRange;
    }

    isTimeRangeVisible(): boolean {
        let hiddenReports = ["AgentIdIO", "MaxMinAvg", "AgentPause"];
        if (hiddenReports.indexOf(this.report["report_Code"]) > -1) return false;
        return true;
    }

    changeSysAgentNoCalls(ev) {
        this.gridItem.setup.sysAgentNoCalls = ev.checked;
    }

    changeExlRowQName(ev) {
        this.gridItem.setup.sysShowEmpty = ev.checked;
    }

    modelChange() {
        let setup = this.gridItem.setup;
        let isCompleted = true;

        var keyColumns = this.columns?.filter(c => c.isKey).map(c => c.labelCode) || [];

        var isValidForChart: boolean = !this.selectedReport.disableCharts;
        if (!setup.columns || setup.columns.length > keyColumns.length + 4) isValidForChart = false;
        // var types = [...new Set(setup.columns?.filter(f => keyColumns.indexOf(f) < 0).map(c => this.columns.find(f => f.labelCode == c)?.dbType))] || [];
        const types = [
            ...new Set(
                (setup.columns ?? [])
                    .filter(f => keyColumns.indexOf(f) < 0)
                    .map(c => this.columns.find(f => f.labelCode === c)?.dbType)
            )
        ];
        if (types.length > 1 || types.indexOf(7) < 0) isValidForChart = false;

        if (setup.columns && !isValidForChart) {
            this.visualTypedisabledItems = [0, 1, 2, 3];
        } else {
            this.visualTypedisabledItems = [3];
        }

        if (this.columns?.length > 0 && this.visualTypedisabledItems.indexOf(this.gridItem.type) > -1) {
            this.gridItem.type = null;
        }

        if (this.gridItem.type == null) isCompleted = false;
        if (setup.reportId == null) isCompleted = false;
        if (this.serviceNumbers?.length > 0 && !setup.serviceNumber) isCompleted = false;

        if (!setup.columns || setup.columns.length < keyColumns.length + 1) isCompleted = false;

        if (setup.period?.type == 0 && (!setup.period.from || !setup.period.to)) isCompleted = false;
        if (setup.period?.type == 1 && (!this.relativeFromCompleted || !this.relativeToCompleted)) isCompleted = false;
        this.completedNotifier.emit(isCompleted);
    }
}
